<div class="fixed z-50 mt-20 top-0 right-0 m-4">
    <div class="w-60 h-20 gap-2 bg-green-500 rounded-lg p-2 transform transition-transform duration-300 flex justify-center items-center ease-in-out translate-x-full toast-enter">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-white w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg> 
      <span class="text-white font-bold"> {{ message }} </span>           
    </div>
</div>